import { render, staticRenderFns } from "./BaseInfoButton.vue?vue&type=template&id=1dd1655f&"
import script from "./BaseInfoButton.vue?vue&type=script&lang=ts&"
export * from "./BaseInfoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports